module.exports = __webpack_public_path__ + "img/4.20a4a355.png";